// extracted by mini-css-extract-plugin
export var addToCartButton = "_u1-b";
export var arrowButtonContainer = "_u1-9";
export var arrowButtonIcon = "_u1-a";
export var carouselArrowButton = "_u1-6";
export var carouselElementContainer = "_u1-1";
export var left = "_u1-7";
export var productDisplayCarouselContainer = "_u1-0";
export var productTileContainer = "_u1-2";
export var productTileImage = "_u1-4";
export var productTileImageContainer = "_u1-3";
export var productTileTitle = "_u1-5";
export var right = "_u1-8";
export var sliderOverflow = "_u1-c";